// We create a new price on stripe for industry Accountants and Bookkeepers.
// Created on CADDIE-290 (original name is BAS Agent) and updated on CADDIE-323 (renamed)
// If we need to update the industry name or identifier in the future,
// We might also want to update this file to make sure the functions that reference following variables work.

/**
 * The industry name of Accountants and Bookkeepers industry.
 * We also want to update this variable if the industry name changed on caddie portal.
 */
export const accountantsIndustryName = 'Accountants and Bookkeepers';

/**
 * The industry identifier of Accountants and Bookkeepers industry.
 * We also want to update this variable if the industry name changed on caddie portal.
 */
export const accountantsIndustryIdentifier = 'accountants-and-bookkeeping-cpd';



// WEBPACK FOOTER //
// ./src/constants/accountants-and-bookkeeping-industry.js